import * as React from "react"
import * as Immutable from 'immutable'
import { BooleansOf } from "../../../utils/types";
import { snakeCase } from "lodash";

type Props<T> = {
  advert: T
  booleans: Immutable.OrderedSet<BooleansOf<T>>
  translate: (s: BooleansOf<T>) => string
}

export default function<T extends { [key: string]: any }>(props: Props<T>) : JSX.Element {
  return props.booleans.count() > 0 ? <ul className="features features--compact features--three-col">
    {props.booleans.map(b => (
      <li key={b} className="features__item">
        {props.translate(b)}
      </li>
    ))}
  </ul> : <></>
}
